<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'aos/dist/aos.css';
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}
</style>
